import React, { useEffect } from 'react';
import s from './Thanks.scss';
import Toast from '../../assets/icons/Toast.svg?url';
import AscendLogo from '../../assets/icons/AscendLogo.svg?url';
import { useTranslation } from '@wix/wix-i18n-config';
import { ClientOffering } from '../../services/client-offering';
import { getDashboardURL } from '../../services/urls';
import { getQueryParam, navigateToUrl } from '../../services/window-utils';
import { biLogger } from '../../globals';

export interface ThanksProps {
  invoiceNum: string | null;
  msid: string;
  data: ClientOffering;
}

const Thanks = (props: ThanksProps) => {
  const { t } = useTranslation();

  const { invoiceNum, msid, data } = props;
  const purchasedPackage =
    data.getCurrentCycleName() || t('thanks.defaultPackageName');

  const packageId = getQueryParam().get('productId') || '';
  const package_name = data.getProductNameById(packageId) || '';
  const cycleId = getQueryParam().get('cycleIntervalCount') || '';
  const cycle_name = getQueryParam().get('cycleIntervalUnit') || '';

  useEffect(() => {
    biLogger.init();
    biLogger.thanksPageOpen({ packageId, package_name, cycleId, cycle_name });
  }, [cycleId, cycle_name, packageId, package_name]);

  const goToDashboard = () => {
    biLogger.thanksButtonClick({
      packageId,
      package_name,
      cycleId,
      cycle_name,
    });
    navigateToUrl(getDashboardURL(msid));
  };

  return (
    <div className={s.thanks} data-hook="thanks">
      <div className={s.logoContainer} data-hook="logo">
        <img className={s.logo} src={AscendLogo} alt="Ascend Logo" />
      </div>
      <div className={s.title} data-hook="title">
        <span>{t('thanks.title')}</span>
      </div>
      <img className={s.toast} src={Toast} data-hook="toast" alt="Toast" />
      <div className={s.invoiceNum} data-hook="invoiceNum">
        {t('thanks.invoiceNum', { invoiceNum })}
      </div>
      <div className={s.message} data-hook="message0">
        {t('thanks.message.00', { purchasedPackage })}
      </div>
      <div className={s.message} data-hook="message1">
        {t('thanks.message.01')}
      </div>
      <button
        className={s.finishBtn}
        onClick={() => goToDashboard()}
        data-hook="finishBtn"
      >
        {t('thanks.button')}
      </button>
    </div>
  );
};

export default Thanks;
